import type { ApiVaultPreferences } from '@izimi/api';

// May implement other preferences in the future, for now only afterDeath
class VaultPreferences implements ApiVaultPreferences {
  afterDeath: ApiVaultPreferences['afterDeath'];

  constructor(vaultPreferences: ApiVaultPreferences) {
    this.afterDeath = vaultPreferences.afterDeath;
  }

  get isConfirmed() {
    return this.afterDeath.confirmed;
  }

  get isEnabled() {
    return this.afterDeath.transferTarget === 'HEIRS_AND_CONTACTS';
  }

  get isHeirsAll() {
    return this.afterDeath.heirsDocumentSelection.selectionType === 'ALL';
  }

  get oldHeirsDocumentIds() {
    return this.afterDeath.heirsDocumentSelection.documents.map((d) => d.documentId);
  }
}

export default VaultPreferences;
